import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails12 = () => {
  const cbc19Data = {
    title: "Utpann CBC-19",
    image: "/assets/Product/img12.png",
    category: "Carrier Based Consortia",
    description:
      "CBC-19 (Carrier Based Consortia) is a balanced blend of beneficial microbes that work together to improve soil biological activity. It enhances nutrient availability, root development, and overall crop growth through synergistic microbial action. Regular use of CBC-19 improves soil health, crop resilience, and sustainable productivity.",
    price: "2000",
    priceNote: "Per 500gm Pack (Gujarat) (Inc GST)",
    recommendations: ["All Crops", "Improve Soil Microbial", "Improve Crops"],
    specsTitle: "FCO-1985 Technical Specifications :",
    specs: [
      {
        label: "Individual organism viable count",
        value:
          "CFU in a mixture of any two of following micro-organisms: CFU minimum Azotobacter or Azospirillum 1x10(7) cells per gram. CFU minimum PSB 1x10(7) cells per gram. CFU minimum KSB 1x10(7) cells per gram.",
      },
      { label: "Total viable count", value: "CFU minimum 3x10(7) cell/gram" },
    ],
    packaging: [
      { label: "Bulk", value: "1000 MT FIBC" },
      { label: "Standard Pack", value: "100gm" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Fixes atmospheric nitrogen, reducing the need for synthetic fertilizers",
      "Solubilizes phosphate for better root uptake and plant growth",
      "Mobilizes potassium, enhancing stress tolerance in plants",
      "Improves soil structure and enhances microbial bio-diversity",
      "Promotes rapid seed germination and uniform plant growth",
      "Increases root development and nutrient absorption efficiency",
      "Enhances disease resistance and stress tolerance in crops",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={cbc19Data} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails12;
